<template>
        <ion-page>
            <ion-header :translucent="true">
            <ion-toolbar>
                <ion-buttons slot="start">
                <ion-menu-button color="primary"></ion-menu-button>
                </ion-buttons>
                <ion-title>My Sales</ion-title>
            </ion-toolbar>
            </ion-header>
            
            <ion-content :fullscreen="true">
            <ion-header collapse="condense">
                <ion-toolbar>
                <ion-title size="large">My Sales</ion-title>
                </ion-toolbar>
            </ion-header>
            
            <div id="container">
                <DataTable :loading="loading" class="p-datatable-sm" showGridlines :value="requisitions" :lazy="true" :paginator="true" :rows="perPage" :totalRecords="total"  @page="onPage($event)" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink" responsiveLayout="stack" :rowClass="data=>{ return 'dataRow'}" :stripedRows="true">
                    <template #loading>
                        Loading data, please wait...
                    </template>
                    <template #empty>
                        No records found
                    </template>
                    <Column field="serial" header="#"></Column>
                    <Column field="id" header="ID"></Column>
                    <Column field="client" header="Client"></Column>
                    <Column field="company" header="Company"></Column>
                    <Column field="shipName" header="Ship"></Column>
                    <Column field="port" header="Port"></Column>
                    <Column field="installationDate" header="Installation Date"></Column>
                    <Column field="contact" header="Contact Person"></Column>
                    <Column field="status" header="Installation Status"></Column>
                    <!-- <Column field="updatedBy" header="Updated By">
                        <template #body="{data}">
                            <div v-html="data.details"></div>
                        </template>
                    </Column> -->
                </DataTable>
            </div>
            </ion-content>
        </ion-page>
</template>

<script >
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/vue';
import { defineComponent } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

export default defineComponent({
  name: 'My Sales',
  data(){
      return {
          requisitions:[],
          loading:false,
          perPage:10,
          total:0,
      }
  },
  mounted(){
      this.loadData(0);
  },
  methods:{
      async loadData(page){
          const data={
              'page':page + 1,
              'username':window.localStorage.username,
              'password':window.localStorage.password,
          };
          this.loading=true;
        this.$http.post('mySales',data).then(response=>{
            // const rows=[];
            this.perPage=response.data.per_page;
            this.total=response.data.total;
            let serial= (page * this.perPage) + 1;
            const reqs=[];
            for(const req of response.data.data){
                reqs.push({
                    serial: serial++,
                    id:req.id,
                    shipName:req.ship_name +" "+ req.m_number +" "+ req.ship_type.ship_type_name,
                    company:req.client.company.company_name,
                    client:req.client.client_name  + ' (' + req.client.mobile  + ')',
                    contact: req.contact_person  + ' (' + req.contact_person_mobile + ')',
                    port:req.port.port_name,
                    installationDate:req.installation_date,
                    status: req.requisition_status,
                });
            }
            this.requisitions=reqs;
            console.log(this.requisitions);
            this.loading=false;
        });

      },
      onPage(event){
          this.loadData(event.page);
      }
  },
  components: {
    IonButtons,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    DataTable,
    Column
  }
});
</script>

<style scoped>
.dataRow:nth-child(even){
    background-color: #f2f2f2 !important;
}
</style>